export default __webpack_public_path__ + "static/media/motorbike.a0a8be40.png";